export default {
  ebookPage: {
    all: { ID: 772, TR: "全部" },
    driveType: { ID: 1066, TR: "驱动类型" },
    motor: { ID: 830, TR: "电机" },
    diesel: { ID: 1069, TR: "柴油机" },
    noProfile: { ID: 2367, TR: "暂无简介" },
    serieslist: { ID: 1, TR: "电子样本" },
    motorFrequency: { ID: 72, TR: "电机频率" },
    motorStandard: { ID: "", TR: "Unit Standard" },
    displayMode: { ID: 664, TR: "显示方式" },
    list: { ID: 665, TR: "列表" },
    grid: { ID: 666, TR: "网格" },
    keyWord: { ID: 661, TR: "关键词" },
    keyWordRule: { ID: 1003, TR: "请输入关键字" },
    view: { ID: 251, TR: "查询" },
    queryResults: { ID: 2368, TR: "查询结果" },
    operation: { ID: 1012, TR: "操作" },
    download: { ID: 448, TR: "下载" },
    type: { ID: 246, TR: "类型" },
    name: { ID: 446, TR: "名称" },
    updateTime: { ID: 758, TR: "更新时间" },
    version: { ID: 759, TR: "文件版本" },
    lang: { ID: 449, TR: "语言" },
    size: { ID: 1489, TR: "文件尺寸" },
    desc: { ID: 447, TR: "描述" },
    emptyFlowAndHead: { ID: 2426, TR: "流量和扬程不能为空" },
    details: { ID: 983, TR: "详情" },
    noData: { ID: "", TR: "暂无数据" },
    pumpList: { ID: 123, TR: "水泵列表" },
    spectrumList: { ID: 6, TR: "系列型谱" },
    modelDrawing: { ID: 183, TR: "实物图" },
    seriesDescription: { ID: 145, TR: "系列说明" },
    seriesDocuments: { ID: 687, TR: "系列文档" },
    video: { ID: 688, TR: "视频" },
    model_3D: { ID: 132, TR: "三维模型" },
    export: { ID: 277, TR: "导出" },
    no: { ID: 689, TR: "序号" },
    flow: { ID: 47, TR: "流量" },
    head: { ID: 48, TR: "扬程" },
    catalog: { ID: 2337, TR: "按类型" },
    selectIndustry: { ID: 2369, TR: "选择行业" },
    choosePump: { ID: "", TR: "选择泵型" }, //yy加一个选择泵业
    allSeries: { ID: 1963, TR: "所有系列" },
    productStructure: { ID: "", TR: "产品结构" },
    screen: { ID: "", TR: "筛选" },
    search: { ID: 177, TR: "搜索" },
    deviceList: { ID: "", TR: "设备列表" },
  },
  selectPage: {
    basicParameters: { ID: 1846, TR: "基本参数" },
    drive: { ID: "", TR: "驱动" },
    acceptanceTolerance: { ID: "", TR: "验收容差" },
    toleranceStandard: { ID: "", TR: "容差标准" },
    toleranceLevel: { ID: "", TR: "容差等级" },
    flowRange: { ID: "", TR: "流量范围" },
    headRange: { ID: "", TR: "扬程范围" },
    otherSelectionCriteria: { ID: "", TR: "其他选型条件" },
    applicationArea: { ID: 2339, TR: "应用领域" },
    municipalWaterManagement: { ID: "", TR: "市政水务" },
    industrialAndMining: { ID: "", TR: "工矿应用" },
    constructionApplications: { ID: "", TR: "建筑应用" },
    filterCriteria: { ID: "", TR: "筛选结果" },

    selparas: { ID: 5, TR: "参数选型" },
    selResult: { ID: 2316, TR: "选型结果" },
    index: { ID: 1451, TR: "首页" },
    selRow: { ID: 724, TR: "列选择" },
    export: { ID: 277, TR: "导出" },
    print: { ID: 193, TR: "打印" },
    previous: { ID: 367, TR: "上一步" },
    physical: { ID: 183, TR: "实物图" },
    series: { ID: 254, TR: "系列" },
    model: { ID: 100, TR: "型号" },
    diagram: { ID: 766, TR: "曲线图" },
    flow: { ID: 47, TR: "流量" },
    head: { ID: 48, TR: "扬程" },
    shaftPower: { ID: 109, TR: "轴功率" },
    efficiency: { ID: 108, TR: "效率" },
    inputPower: { ID: "", TR: "输入功率" },
    unitEfficiency: { ID: "", TR: "机组效率" },
    npsh: { ID: 110, TR: "NPSHr" },
    speed: { ID: 115, TR: "转速" },
    impellerDiameter: { ID: 224, TR: "叶轮直径" },
    details: { ID: 983, TR: "详情" },
    certifiedTraffic: { ID: "", TR: "认证流量" },
    certifiedHead: { ID: "", TR: "认证扬程" },
    certifiedSpeed: { ID: "", TR: "认证转速" },
    pointFlow_150: { ID: "", TR: "150%点流量" },
    pointLift_150: { ID: "", TR: "150%点扬程" },
    pointPower_150: { ID: "", TR: "150%点功率" },
    maxShaftPower: { ID: "", TR: "最大轴功率" },
    deadCenterLift: { ID: "", TR: "关死点扬程" },
    pumpStages: { ID: "", TR: "泵级数" },
    note: { ID: 118, TR: "备注" },
    gotoIndexPage: { ID: 2370, TR: "返回首页" },
    quickSelection: { ID: 2317, TR: "快速选型" },
    advancedSelection: { ID: 2318, TR: "高级选型" },
    workingConditions: { ID: 2319, TR: "工况条件" },
    productSeries: { ID: 2320, TR: "产品系列" },
    driveType: { ID: 2321, TR: "驱动类型" },
    setFrequency: { ID: 2322, TR: "设置频率" },
    moreDesignPoints: { ID: 1443, TR: "更多设计点" },
    hide: { ID: 2323, TR: "隐藏" },
    secondDpFlow: { ID: 2324, TR: "第二设计点流量" },
    secondDpHead: { ID: 2325, TR: "第二设计点扬程" },
    thirdDpFlow: { ID: 2326, TR: "第三设计点流量" },
    thirdDpHead: { ID: 2327, TR: "第三设计点扬程" },
    firePump: { ID: 2289, TR: "消防泵" },
    motorPoleNum: { ID: 2328, TR: "电机级数" },
    moreSet: { ID: 2329, TR: "更多设置" },
    put: { ID: 2330, TR: "收起" },
    expand: { ID: "", TR: "展开" },
    motorPowerStd: { ID: 2331, TR: "电气标准" },
    mediaName: { ID: 2332, TR: "介质名称" },
    mediumTemperature: { ID: "", TR: "介质温度" },
    cleanWater: { ID: 464, TR: "清水" },
    maxTemperature: { ID: 2333, TR: "最高温度" },
    customMediaProp: { ID: 2334, TR: "自定义介质属性" },
    maxDensity: { ID: 2335, TR: "最大密度" },
    mediumViscosity: { ID: 2336, TR: "介质粘度" },
    nextStep: { ID: 368, TR: "下一步" },
    selectAll: { ID: 97, TR: "全选" },
    reselect: { ID: 366, TR: "重选" },
    invert: { ID: "", TR: "反选" },
    modelList: { ID: 442, TR: "型号列表" },
    byType: { ID: 2337, TR: "按类型" },
    byIndustry: { ID: 2338, TR: "按行业" },
    byMedia: { ID: 2371, TR: "按介质" },
    type: { ID: 246, TR: "类型" },
    applicationArea: { ID: 2339, TR: "应用领域" },
    flowRule: { ID: 2553, TR: "请输入流量" },
    headRule: { ID: 1149, TR: "请输入扬程" },
    leastOneType: { ID: "", TR: "至少选择一种类型" },
    seriesRule: { ID: 2342, TR: "至少选择一个系列" },
    hangyeRule: { ID: 2372, TR: "至少选择一个行业" },
    jiezhiRule: { ID: 2373, TR: "至少选择一种介质" },
    dieselEngineSpeedRule: { ID: 2341, TR: "请输入柴油机转速" },
    dieselEngineSpeed: { ID: 2340, TR: "柴油机转速" },
    pleaseSelect: { ID: 2022, TR: "请选择" },
    custom: { ID: 2180, TR: "自定义" },
    unlimited: { ID: "", TR: "不限" },
    toleranceStand: { ID: "", TR: "验收容差标准" },
    toleranceGrade: { ID: "", TR: "验收容差等级" },
    MinFlowPercentage: { ID: 677, TR: "最小流量百分比" },
    MaxFlowPercentage: { ID: 678, TR: "最大流量百分比" },
    MinHeadPercentage: { ID: 679, TR: "最小扬程百分比" },
    MaxHeadPercentage: { ID: 680, TR: "最大扬程百分比" },
    findErr1: { ID: "", TR: "未查找到相关型号,请修改相关选型参数" },
    findErr2: { ID: "", TR: "未查找到相关型号,将在三秒后返回上一页" },
    QPerQBep: { ID: "", TR: "额定点" },
    PerRated: { ID: "", TR: "铭牌参数综合偏差" },
    PerRatedQ: { ID: "", TR: "铭牌参数流量偏差" },
    sortMethod: { ID: "", TR: "排序方式" },
    efficiencySort: { ID: "", TR: "效率排序" },
    qPerQBepSort: { ID: "", TR: "综合排序" },
    enum: { ID: 331, TR: "数量" }, //yy add--
    modelSelection: { ID: 26, TR: "选型" },
    mediaLibrary: { ID: "", TR: "介质库" },
    volumeConcentration: { ID: "", TR: "体积浓度" },
    mediaDescription: { ID: "", TR: "介质说明" },
    isMediumParticles: { ID: "", TR: "含有介质颗粒" },
    vbr: { ID: "", TR: "变速率" },
    cuttingRate: { ID: "", TR: "切割率" },
    salesPrice: { ID: "", TR: "销售价" },
    originalImpellerDiameter: { ID: "", TR: "原始叶轮直径" },
    ratedSpeed: { ID: "", TR: "额定转速" },
    guidePrice: { ID: "", TR: "指导价" },
    secondDirectory: { ID: "", TR: "二级目录" },
    allowCutting: { ID: "", TR: "允许切割" },
    allowFrequencyConversion: { ID: "", TR: "允许变频" },

    efficiencyAndNPSH: { ID: "", TR: "效率和汽蚀" },
    minimumEfficiency: { ID: "", TR: "最低效率" },
    attributeFiltering: { ID: "", TR: "属性过滤" },
    importedCaliber: { ID: "", TR: "进口口径" },
    exportCaliber: { ID: "", TR: "出口口径" },
    motorParameters: { ID: "", TR: "电机参数" },
    helpChoose: { ID: "", TR: "帮我选" },

    similarConversion: { ID: "", TR: "相似换算" },
    parameterDesign: { ID: "", TR: "参数设计" },
    selectionCondition: { ID: "", TR: "选型条件" },
    designRequirement: { ID: "", TR: "设计要求" },
    calculationParameters: { ID: "", TR: "计算参数" },
    mediumDensity: { ID: "", TR: "介质密度" },
    selectionMethod: { ID: "", TR: "选型方法" },
    pumpType: { ID: "", TR: "泵型" },
    impellerType: { ID: "", TR: "叶轮类型" },
    modelLibrary: { ID: "", TR: "模型库" },
    fixedSpeed: { ID: "", TR: "定转速" },
    specificSpeed: { ID: "", TR: "比转速" },
    convertRangeBySpecificSpeed: { ID: "", TR: "比转速换算范围" },
    efficiencyCorrection: { ID: "", TR: "效率修正" },
    recommendModel: { ID: "", TR: "推荐模型" },
    DifferenceInSpecificSpeed: { ID: "", TR: "比转速差值" },
    originalModelInformation: { ID: "", TR: "原模型信息" },
    afterConversion: { ID: "", TR: "换算后" },
    scaleRatio: { ID: "", TR: "缩放系数" },
    yelunTips: { ID: "", TR: "请输入叶轮直径"},
    e_requirements:{ID:"",TR:"效率要求"},
    currentMotorPower:{ID:"",TR:"当前电机功率"},
    requiredMotorPower:{ID:"",TR:"要求的电机功率"}, 
  },
  //详情页面
  detailPage: {
    userUnit: { ID: 2117, TR: "用户单位" },
    standardUnit: { ID: 2118, TR: "标准单位" },
    report: { ID: 692, TR: "报告" },
    share: { ID: 693, TR: "分享" },
    costAnalysis: { ID: 570, TR: "成本分析" },
    medium: { ID: 1448, TR: "介质" },
    model_3D: { ID: 132, TR: "三维模型" },
    scanQRShare: { ID: 2354, TR: "扫描二维码分享" },
    view: { ID: 251, TR: "查询" },
    close: { ID: 459, TR: "关闭" },
    setUp: { ID: 469, TR: "设定" },
    flowUnits: { ID: 2102, TR: "流量单位" },
    headUnit: { ID: 2103, TR: "扬程单位" },
    powerUnit: { ID: 2355, TR: "功率单位" },
    npshUnit: { ID: "", TR: "汽蚀单位" },
    d2Unit: { ID: "", TR: "叶轮外径单位" },
    followSystem: { ID: "", TR: "跟随系统" },
    exitFull: { ID: 2356, TR: "退出全屏" },
    partNo: { ID: 159, TR: "产品编号" },
    materialGroup: { ID: 1715, TR: "材料组" },
    material: { ID: 1199, TR: "材料" },
    selectionReport: { ID: 237, TR: "选型报告" },
    lang: { ID: 449, TR: "语言" },
    fileFormat: { ID: 1547, TR: "文件格式" },
    buildFile: { ID: 2343, TR: "生成文件" },
    customerInfo: { ID: 780, TR: "客户信息" },
    orderInformation: { ID: 866, TR: "订单信息" },
    setReportContent: { ID: 871, TR: "设置报告内容" },
    reportInformation: { ID: "", TR: "报告信息" },
    projectInformation: { ID: 89, TR: "项目信息" },
    productName: { ID: 863, TR: "产品名称" },
    projectCode: { ID: 1011, TR: "项目编号" },
    projectName: { ID: 785, TR: "项目名称" },
    itemNO: { ID: 786, TR: "工位编号" },
    customerName: { ID: 865, TR: "客户名称" },
    customerAddress: { ID: 952, TR: "客户地址" },
    contactPerson: { ID: 753, TR: "联系人" },
    contactInformation: { ID: 35, TR: "联系方式" },
    email: { ID: 1803, TR: "邮箱" },
    website: { ID: 1804, TR: "网址" },
    country: { ID: 1805, TR: "国家" },
    price: { ID: 868, TR: "产品单价" },
    productModel: { ID: "", TR: "订单中产品型号" },
    pumpPeformance: { ID: 1798, TR: "订单号" },
    purchaseQuantity: { ID: 870, TR: "购买数量" },
    orderNote: { ID: 867, TR: "订单备注" },
    pageReportSet: { ID: 2352, TR: "页面设置" },
    isBWDispplay: { ID: 804, TR: "黑白显示曲线" },
    dataAndCurve: { ID: 801, TR: "数据表和曲线" },
    curveGraph: { ID: 766, TR: "曲线图" },
    sizePicture: { ID: 694, TR: "尺寸图" },
    assemblyDrawing: { ID: 134, TR: "安装图" },
    modelDrawing: { ID: 183, TR: "实物图" },
    explosionDiagram: { ID: "", TR: "爆炸图" },
    modelDrawinUnit: { ID: 2353, TR: "实物图(机组)" },
    structureDrawing: { ID: 185, TR: "结构图" },
    offerText: { ID: 798, TR: "报价文本" },
    companyName: { ID: 995, TR: "公司抬头" },
    companyWebsite: { ID: 1801, TR: "公司网址" },
    performanceCurve: { ID: 218, TR: "性能曲线" },
    assemblyDrawingPart: { ID: 2344, TR: "安装图(单泵)" },
    assemblyDrawingSys: { ID: 2345, TR: "安装图(机组)" },
    outlineDrawing: { ID: "", TR: "安装尺寸图" },
    pumpDimensions: { ID: "", TR: "泵头尺寸图" },
    physical: { ID: 183, TR: "实物图" },
    parameter: { ID: 111, TR: "参数" },
    productFileName: { ID: 694, TR: "尺寸图" },
    data: { ID: 2026, TR: "数据" },
    unit: { ID: 526, TR: "单位" },
    operatingParameters: { ID: 2126, TR: "运行参数" },
    parameterQuery: { ID: 2346, TR: "参数查询" },
    installation: { ID: 2169, TR: "安装信息" },
    motor: { ID: 2170, TR: "电机信息" },
    documents: { ID: 687, TR: "系列文档" },
    properties: { ID: 230, TR: "属性" },
    flow: { ID: 47, TR: "流量" },
    head: { ID: 48, TR: "扬程" },
    frequency: { ID: "", TR: "频率" },
    shaftPower: { ID: 109, TR: "轴功率" },
    efficiency: { ID: 108, TR: "效率" },
    inputPower: { ID: "", TR: "输入功率" },
    unitEfficiency: { ID: "", TR: "机组效率" },
    press: { ID: 1105, TR: "压力" },
    power: { ID: 422, TR: "功率" },

    seriesConnect: { ID: "", TR: "串联" },
    parallelConnect: { ID: "", TR: "并联" },
    method: { ID: "", TR: "方式" },
    update: { ID: "", TR: "更新" },
    number: { ID: "", TR: "台数" },
    queryParams: { ID: "", TR: "查询参数" },

    impellerDia: { ID: 112, TR: "叶轮外径" },
    motorPower: { ID: 682, TR: "电机功率" },
    npsh: { ID: 110, TR: "NPSHr" },
    speed: { ID: 115, TR: "转速" },
    coefficient: { ID: "", TR: "系数" },
    parameterSelection: { ID: 5, TR: "参数选型" },
    allowableRegionMax: { ID: 2347, TR: "允许区域(大)" },
    allowableRegionMin: { ID: 2348, TR: "允许区域(小)" },
    optimalAreaMax: { ID: 2349, TR: "最优区域(大)" },
    optimalAreaMin: { ID: 2350, TR: "最优区域(小)" },
    closeDeadCenter: { ID: 2351, TR: "关死点" },
    bestAdvantage: { ID: 2357, TR: "最优点" },
    workingPoint: { ID: 203, TR: "工作点" },
    flowPoint150: { ID: 2358, TR: "流量150%点" },
    powerPointMax: { ID: 2359, TR: "最大功率点" },
    video: { ID: 688, TR: "视频" },
    picture: { ID: "", TR: "图片" },
    variableSpeedCurve: { ID: 2374, TR: "变速曲线" },
    seriesParallelConnection: { ID: "", TR: "串并联曲线" },
    displaySettings: { ID: 1625, TR: "显示设置" },
    curveExport: { ID: 2375, TR: "曲线导出" },
    chartColor: { ID: 2376, TR: "图表颜色" },
    monochrome: { ID: 139, TR: "单色" },
    multicolour: { ID: "", TR: "彩色" },
    spectrumDisplay: { ID: 2377, TR: "型谱显示" },
    display: { ID: 217, TR: "显示" },
    noDisplay: { ID: 158, TR: "不显示" },
    display_curve: { ID: "", TR: "显示在曲线末端" },
    displayPanel: { ID: "", TR: "显示在面板" },
    onlyShowworkCurve: { ID: 1969, TR: "仅显示工作曲线" },
    speedList: { ID: 2378, TR: "转速列表" },
    addSpeed: { ID: 2379, TR: "添加转速" },
    addPinLv: { ID: "", TR: "添加频率" },
    pleaseEnterSpeed: { ID: 1154, TR: "请输入转速" },
    pleaseEnterHz: { ID: "", TR: "请输入频率" },
    tip: { ID: 286, TR: "提示" },
    define: { ID: 125, TR: "确定" },
    cancel: { ID: 126, TR: "取消" },
    download: { ID: 448, TR: "下载" },
    downloadTips: { ID: "", TR: "请下载桌面程序,导出性能曲线" },
    curve: { ID: 766, TR: "曲线图" },
    document: { ID: 984, TR: "文档" },
    DocumentNone: { ID: "", TR: "文档(无)" },
    Model: { ID: "", TR: "模型" },
    queryPoint: { ID: "", TR: "查询点" },
    productNoSelect: { ID: "", TR: "产品编号选择" },
    watermark: { ID: "", TR: "水印" },
    IsPrintModel3d: { ID: "", TR: "产生三维页面" },
    IsCreateMultiSpeedChart: { ID: "", TR: "产生变频曲线" },
    queryCurve: { ID: "", TR: "查询曲线" }, //yy  add---
    parameterQuery: { ID: "", TR: "参数查询" },
    parameter_s: { ID: "", TR: "参数" },
    parameterCancel: { ID: "", TR: "取消" },
    parameterDetermine: { ID: "", TR: "确定" },
    showDesignPoints: { ID: "", TR: "显示设计点" },
    designPointStyle: { ID: "", TR: "设计点样式" },
    crosshair: { ID: "", TR: "十字线" },
    invertedTriangle: { ID: "", TR: "倒三角" },
    roundDot: { ID: "", TR: "圆点" },
    boldRightAngle: { ID: "", TR: "加粗直角" },
    deviceCurve: { ID: "", TR: "装置曲线" },
    displayIndex: { ID: "", TR: "显示" },
    netHeadValue: { ID: "", TR: "净扬程值" },
    displayCurve: { ID: "", TR: "显示曲线" },
    onlyDisplayCurve: { ID: "", TR: "仅显示工作曲线" },
    showAllCurves: { ID: "", TR: "显示所有曲线" },
    outputChartToCAD: { ID: "", TR: "请下载客户端,客户端才能导出CAD格式文件" },
    inquiry: { ID: "", TR: "询价" },
    productInquiry: { ID: "", TR: "产品询价" },
    address: { ID: "", TR: "地址" },
    contactName: { ID: "", TR: "联系人名称" },
    pumpModel: { ID: "", TR: "泵型号" },
    pumpNumber: { ID: "", TR: "泵数量" },
    submit: { ID: "", TR: "提交" },
    inquirtFormatte1: { ID: "", TR: "请输入联系方式" },
    inquirtFormatte2: { ID: "", TR: "请输入联系人名称" },
    selectMedia: { ID: "", TR: "选择介质" }, //yy add
    cleanWater: { ID: 459, TR: "清水" },
    viewDetail: { ID: 661, TR: "查看详情" },
    sewage: { ID: 21, TR: "污水" },
    viscousSlurry: { ID: "", TR: "污水、渣浆粘稠浆液" },
    chemicalLiquid: { ID: "", TR: "化学液体" },
    hydrocarbons: { ID: "", TR: "化学液体、烃类等" },
    Gas: { ID: "", TR: "气体" },
    gasList: { ID: "", TR: "空气、油气、瓦斯" },
    nameplateParameter: { ID: 2194, TR: "铭牌参数" },
    angle: { ID: 1500, TR: "角度" },
    printCompanyInfo: { ID: "", TR: "打印公司信息" },

    auto: { ID: "", TR: "自动判断" },
    original: { ID: "", TR: "原始方向" },
    clockwise: { ID: "", TR: "顺时针方向" },
    counterclockwise: { ID: "", TR: "逆时针方向" },

    resize: { ID: "", TR: "自适应" },
    zoomIn: { ID: "", TR: "放大" },
    zoomOut: { ID: "", TR: "缩小" },
    highlightModifyArea: { ID: "", TR: "高亮修改区域" },
    move: { ID: "", TR: "移动文本" },

    productConfig: { ID: "", TR: "产品配置" },
    exportSettings: { ID: "", TR: "导出设置" },
    path: { ID: "", TR: "路径" },
    monochromeDisplay: { ID: "", TR: "单色显示" },
    chartSettings: { ID: "", TR: "图表设置" },
    selectionPoint: { ID: "", TR: "选型点" },
    nameplateParameterPoints: { ID: "", TR: "铭牌参数点" },
    operatingArea: { ID: "", TR: "运行区域" },
    optimalArea: { ID: "", TR: "最优区域" },
    deviceArea: { ID: "", TR: "装置曲线" },
    flowHeadLine: { ID: "", TR: "流量扬程线" },
    allHeadCurves: { ID: "", TR: "所有扬程曲线" },
    flowEfficiencyLine: { ID: "", TR: "流量效率线" },
    onlyWorkingCurve: { ID: "", TR: "仅工作曲线" },
    flowPowerLine: { ID: "", TR: "流量功率线" },
    AllPowerCurves: { ID: "", TR: "所有功率曲线" },
    textContent: { ID: "", TR: "文本内容" },
    rotationAngle: { ID: "", TR: "旋转角度" },
    fontSize: { ID: "", TR: "文字大小" },
    alignmentMethod: { ID: "", TR: "对齐方式" },
    fontColor: { ID: "", TR: "文字颜色" },
    blod: { ID: "", TR: "加粗" },
    italic: { ID: "", TR: "倾斜" },
    leftRotation: { ID: "", TR: "左旋转" },
    rightRotation: { ID: "", TR: "右旋转" },
    equivalentLine: { ID: "", TR: "等效线" },
    minFlowCurve: { ID: "", TR: "最小连续流量线" },
    maximumEfficiencyPoint: { ID: "", TR: "高效点" },
    allCurves: { ID: "", TR: "所有曲线" },
    flowNPSHrCurve: { ID: "", TR: "流量汽蚀线" },
    colorStyle: { ID: "", TR: "颜色样式" },
    maxMinWorkingCurve: { ID: "", TR: "最大最小工作曲线" },
    errorTip: { ID: "", TR: "不能小于最小轴功率" },


    addCurve: { ID: "", TR: "添加曲线"},
    addFlowPoint: { ID: "", TR: "添加流量点"},
    byFrequency: { ID: "", TR: "按频率"},
    bySpeed: { ID: "", TR: "按转速"},
    byOperatingPoint: { ID: "", TR: "按运行点"},
    queryInfo: { ID: "", TR: "查询信息"},
    pointName: { ID: "", TR: "点名"},
  },
  //报表分析
  LCC: {
    Analysis: { ID: 568, TR: "分析" },
    accumulationCurve: { ID: 927, TR: "年度累计曲线" },
    statisticalChart: { ID: 928, TR: "单年统计图" },
    workingPointFlow: { ID: 554, TR: "工作点流量" },
    default: { ID: 921, TR: "默认" },
    heating: { ID: 922, TR: "供暖" },
    pressurize: { ID: 923, TR: "增压" },
    custom: { ID: 924, TR: "自定义" },
    status: { ID: 851, TR: "状态" },
    flowRatio: { ID: 932, TR: "流量比例" },
    timeScale: { ID: 933, TR: "时间比例" },
    fullLoad: { ID: 934, TR: "全负荷" },
    partialLoad: { ID: 936, TR: "部分负荷" },
    nightCoolingOperation: { ID: 938, TR: "夜间降温运行" },
    lowLoad: { ID: 937, TR: "低负荷" },
    load: { ID: 2381, TR: "负荷" },
    energyCosts: { ID: 560, TR: "能耗成本" },
    workingDays: { ID: 555, TR: "每年大致工作天数" },
    workingHours: { ID: 556, TR: "每年大致工作小时" },
    powerFees: { ID: 566, TR: "电费" },
    per: { ID: 564, TR: "每度" },
    risiPowerPrice: { ID: 2382, TR: "电费上涨" },
    eachYear: { ID: 565, TR: "每年" },
    CalcCycle: { ID: 557, TR: "计算周期" },
    year: { ID: 558, TR: "年" },
    interestRate: { ID: 559, TR: "利率" },
    droop: { ID: 567, TR: "效率下降" },
    co2Ratio: { ID: 920, TR: "CO2系数" },
    conversionFactor: { ID: 2427, TR: "煤炭折算系数" },
    maintenanceCost: { ID: 535, TR: "维护维修成本" },
    thousand: { ID: 2383, TR: "千元" },
    maintenance: { ID: 2384, TR: "维护和维修" },
    runningCost: { ID: 541, TR: "运行费用" },
    downtimeAndLoss: { ID: 539, TR: "生产停工和损耗" },
    environmentalFee: { ID: 540, TR: "环境保护费" },
    othersFee: { ID: 777, TR: "其他年费用" },
    initialCost: { ID: 548, TR: "一次性初始成本" },
    orderCost: { ID: 2385, TR: "设备采购费用" },
    installDebugCharge: { ID: 550, TR: "安装和调试" },
    tonAndkW: { ID: 2386, TR: "吨/万千瓦" },
    mapOfCosts: { ID: 925, TR: "费用图" },
    costItem: { ID: 929, TR: "费用项" },
    cost: { ID: 930, TR: "费用" },
    percentage: { ID: 931, TR: "百分比" },
    maintenanceAndRepair: { ID: 542, TR: "维修和护理" },
    co2: { ID: "", TR: "CO2" },
    coalConsumption: { ID: 2388, TR: "煤耗量" },
    totalAnnualCost: { ID: 942, TR: "年总费用" },
    co2TotalEmissions: { ID: 2389, TR: "co2总排放量" },
    tenThousand: { ID: 940, TR: "万" },
    tenThousandTon: { ID: 2390, TR: "万吨" },
    calculationPeriod: {
      ID: "",
      TR: "请输入计算周期!",
    }, //yy ---add
    scaleTime: {
      ID: "",
      TR: "请输入时间比例!",
    },
    sumProportions: {
      ID: "",
      TR: "请输入时间比例之和为100%!",
    },
    electricCharge: {
      ID: "",
      TR: "请输入电费(每度)!",
    },
    coefficient_c: {
      ID: "",
      TR: "请输CO2系数!",
    },
    conversionCoefficient: {
      ID: "",
      TR: "请输入煤炭折算系数!",
    },
  },
  //首页
  indexPage: {
    corpIntroduction: { ID: 30, TR: "公司介绍" },
    basicInformation: { ID: "", TR: "基础信息" },
    enterpriseHonors: { ID: 32, TR: "企业荣誉" },
    enterpriseStyle: { ID: 2286, TR: "企业风貌" },
    organizationStructure: { ID: "", TR: "组织结构" },
    corporateCulture: { ID: "", TR: "企业文化" },
    introductionToPumpAnimation: { ID: "", TR: "泵型动画介绍" },
    companyPortfolio: { ID: "", TR: "公式组合" },
    salesNetwork: { ID: 31, TR: "销售网络" },
    performanceSelection: { ID: 2287, TR: "水力性能选型" },
    productSearch: { ID: 771, TR: "产品搜索" },
    contactinformation: { ID: 35, TR: "联系方式" },
    myProject: { ID: 1716, TR: "我的项目" },
    ebook: { ID: 1, TR: "电子样本" },
    pdfFile: { ID: 1717, TR: "纸质样本" },
    application: { ID: 2391, TR: "行业应用" },
    intelligentSelection: { ID: 68, TR: "智能选型" },
    firePump: { ID: 2289, TR: "消防泵" },
    flow: { ID: 47, TR: "流量" },
    head: { ID: 48, TR: "扬程" },
    type: { ID: 246, TR: "类型" },
    more: { ID: 734, TR: "更多" },
    nextStep: { ID: 368, TR: "下一步" },
    zmSearch: { ID: 2392, TR: "按字母" },
    alphaList: { ID: "", TR: "字母列表" },
    byType: { ID: 2337, TR: "按类型" },
    byIndustry: { ID: 2338, TR: "按行业" },
    product: { ID: 721, TR: "产品" },
    material: { ID: 722, TR: "资料" },
    byProductLine: { ID: "", TR: "按产品线" },
    model_3D: { ID: 132, TR: "三维模型" },
    about_us: { ID: 2393, TR: "关于我们" },
    product_catalog: { ID: 2394, TR: "产品目录" },
    product_selection: { ID: 2395, TR: "产品选型" },
    letter_search: { ID: 2396, TR: "字母搜索" },
    application_HY: { ID: 2391, TR: "行业应用" },
    application_area: { ID: 2339, TR: "应用领域" },
    sample_Model: { ID: 2397, TR: "样本模型" },
    searchByPumpImg: { ID: "", TR: "按产品图搜索" },
    pleaseSelect: { ID: 2022, TR: "请选择" },
    corpInfo: { ID: 1802, TR: "公司信息" },
    add: { ID: 710, TR: "公司地址" },
    tel: { ID: 2398, TR: "联系电话" },
    email: { ID: 2399, TR: "企业邮箱" },
    hotline: { ID: 2400, TR: "全国同一服务热线" },
    helpManual: { ID: "", TR: "帮助手册" },
    changePassword: { ID: 23, TR: "修改密码" },
    viewNow: { ID: 170, TR: "立即查看" },
    quick: { ID: "", TR: "快速" },
    sampleBook: { ID: "", TR: "产品样本" },
    simpleAndDirect: { ID: "", TR: "清晰简捷" },
    clearClassification: { ID: "", TR: "分类明确" },
    quickProductSelection: { ID: "", TR: "产品快速选取" },
    productSamplePreview: { ID: "", TR: "产品样本预览" },
    productNameAtoZ: { ID: "", TR: "产品名称A-Z" },
    findApplications: { ID: "", TR: "发现适合您需求的应用" },
    feedBack: { ID: "", TR: "问题反馈" },
    feedbackContent: { ID: "", TR: "反馈内容" },
    feedbackRule: { ID: "", TR: "联系人或联系方式不能为空" },
    problemType: { ID: "", TR: "问题类型" },
    rorExample: { ID: "", TR: "例如：软件问题、曲线错误" },
    classAndSelection: { ID: "", TR: "分类选型" },
    industrySelection: { ID: "", TR: "行业选型" },
    projectList: { ID: "", TR: "项目列表" },
    customerList: { ID: "", TR: "客户列表" },

    intelligentSelectionSub: { ID: "", TR: "根据参数筛选，精准选出所需的型号" },
    marketSector: { ID: "", TR: "市场领域" },
    marketSectorSub: { ID: "", TR: "根据设备应用领域，呈现所需的型号" },
    alphabeticSort: { ID: "", TR: "字母排序" },
    alphabeticSortSub: { ID: "", TR: "根据字母排序，罗列所有的设备系列" },
    enterSelect: { ID: "", TR: "进入选型" },
    companyWebsite: { ID: "", TR: "企业官网" },
  },
  simpleLoginPage: {
    login: { ID: 673, TR: "登录" },
    register: { ID: 380, TR: "注册" },
    enterVerificCode: { ID: 2401, TR: "请输入验证码" },
    verificCodeError: { ID: 2402, TR: "验证码错误" },
    loginPrompt: { ID: 2403, TR: "登录提示" },
    passwordError: { ID: 400, TR: "密码错误" },
    loginSuccessful: { ID: 2404, TR: "登录成功,正在跳转~" },
    AccountLogin: { ID: 2405, TR: "账户登录" },
    CodeScanningLogin: { ID: 2290, TR: "扫码登录" },
    registerInfo: {
      ID: 2291,
      TR: "如果您还没有加入我们，可以点击下方的注册成为我们的一员",
    },
    registerInfoTitle: { ID: 2292, TR: "新用户" },
    loginInfo: {
      ID: 2293,
      TR: "如果您已经是我们中的一员可以点击下方的登录，进入到我们的平台",
    },
    loginInfoTitle: { ID: 2294, TR: "我们中的一员" },
    userType: { ID: 2295, TR: "用户类型" },
    loginName: { ID: 2296, TR: "账户名" },
    password: { ID: 378, TR: "密码" },
    userType0: { ID: 703, TR: "内部人员" },
    userType1: { ID: 2297, TR: "外部人员" },
    userType2: { ID: "", TR: "代理商" },
    phoneNumber: { ID: 379, TR: "手机号" },
    email: { ID: 1803, TR: "邮箱" },
    forgetPassword: { ID: "", TR: "忘记密码" },
    sendSuccess: { ID: "", TR: "发送成功" },
    verifyAccount: { ID: "", TR: "账号验证" },
    fillInInformation: { ID: "", TR: "填写信息" },
    registerSuccess: { ID: 890, TR: "注册成功" },
    registerTips: { ID: "", TR: "请填写您注册时的手机号" },
    forgetEmailTips: { ID: "", TR: "请填写您注册时的邮箱" },

    verifyCode: { ID: 700, TR: "验证码" },
    send: { ID: "", TR: "发送" },
    userAccount: { ID: "", TR: "用户账号" },
    oldPassword: { ID: "", TR: "旧密码" },
    oldPsdTips: { ID: "", TR: "请输入旧密码" },
    newPassword: { ID: 397, TR: "新密码" },
    newPsdTips: { ID: "", TR: "请输入新密码" },
    oldPwdRule: { ID: "", TR: "旧密码不能为空" },
    newPwdRule: { ID: "", TR: "新密码不能为空" },
    oldAndNewPwdRule: { ID: "", TR: "新旧密码不能一致" },
    enterPwdAgain: { ID: 2303, TR: "请再次输入密码" },
    enterTwoPwdDisaccord: { ID: "", TR: "两次输入密码不一致" },
    changeSuccess: { ID: 636, TR: "修改成功" },
    pwdRule: { ID: 399, TR: "密码不一致" },
    accountSettings: { ID: "", TR: "账号设置" },
    confirmPassword: { ID: "", TR: "确定密码" },
    realName: { ID: "", TR: "用户名" },
    corpName: { ID: 102, TR: "公司名称" },
    corpAddress: { ID: 710, TR: "公司地址" },

    formValidate: {
      email0: { ID: 773, TR: "请输入邮箱" },
      email1: { ID: 2298, TR: "请输入正确的邮箱格式" },
      TelPhone0: { ID: 2299, TR: "请输入手机号码" },
      TelPhone1: { ID: 2300, TR: "请输入正确的手机号码格式" },
      pass0: { ID: 2301, TR: "请输入密码" },
      pass1: { ID: 2302, TR: "请输入密码长度为8~18位" },
      pass2: { ID: 2303, TR: "请再次输入密码" },
      pass3: { ID: 2304, TR: "两次密码输入不一样" },
      pass4: { ID: "", TR: "密码必须包含大写或小写字母、数字、特殊字符" },
      loginName0: { ID: 2305, TR: "请输入登录名" },
      loginName1: { ID: 2306, TR: "请输入登录名长度为6~18位" },
      userName0: { ID: 2307, TR: "请输入用户姓名" },
      corpName0: { ID: 2308, TR: "请输入公司名称" },
      corpAddress0: { ID: "", TR: "请输入公司地址" },
      tips1: { ID: "", TR: "不能包含特殊符号'或（）或*" },
    },
  },
  // 头部header栏
  header: {
    serieslist: { ID: 1, TR: "电子样本" },
    selparas: { ID: 5, TR: "参数选型" },
    lang: { ID: 449, TR: "语言" },
    cn: { ID: 714, TR: "中文" },
    en: { ID: 296, TR: "英文" },
    ko: { ID: 299, TR: "韩文" },
    es: { ID: 2360, TR: "西班牙文" },
    russian: { ID: 302, TR: "俄文" },
    Applications: { ID: 2309, TR: "其他应用" },
    danji: { ID: 2310, TR: "单机版" },
    android: { ID: 2311, TR: "安卓" },
    ios: { ID: 2312, TR: "苹果" },
    wechat: { ID: 2313, TR: "微信" },
    userInfo: { ID: 2423, TR: "账户信息" },
    logout: { ID: 707, TR: "退出登录" },
    collectList: { ID: 2406, TR: "收藏列表" },
    compareList: { ID: 840, TR: "比较列表" },
    collect: { ID: 1705, TR: "收藏" },
    addCollect: { ID: 2407, TR: "加入收藏" },
    deleteCollect: { ID: 842, TR: "清除收藏" },
    compare: { ID: 691, TR: "比较" },
    addCompare: { ID: 839, TR: "加入比较" },
    deleteCompare: { ID: 841, TR: "清除比较" },
    comparisonAdded: { ID: 2408, TR: "已经加入比较列表" },
    addComparSueecss: { ID: 2409, TR: "加入比较列表成功" },
    clearComparList: { ID: 2410, TR: "确认清除比较列表" },

    clearComparSuccess: { ID: 2411, TR: "清除比较列表成功" },
    confirmDelCompar: { ID: 2412, TR: "确认删除此型号的比较" },
    deleteSuccess: { ID: 2413, TR: "删除成功" },
    confirmDelCollect: { ID: 2414, TR: "确认删除此收藏" },
    confirmClearCollect: { ID: 2415, TR: "确认清除收藏" },
    clearCollectSueecss: { ID: 2416, TR: "清除成功" },
    collecExists: { ID: 2417, TR: "收藏已存在" },
    collectSuccess: { ID: 2418, TR: "收藏成功" },
    login: { ID: 673, TR: "登录" },
    information: { ID: 2419, TR: "个人信息" },
    tipInfo: { ID: 2420, TR: "您确定要退出系统吗" },
    tip: { ID: 289, TR: "提示" },
    define: { ID: 125, TR: "确定" },
    cancel: { ID: 126, TR: "取消" },
    collectTip: { ID: 2421, TR: "收藏列表为空" },
    compareTip: { ID: 2422, TR: "比较列表至少需要两项" },
    accountModification: { ID: "", TR: "账户修改" },
    accountInfo: { ID: 2423, TR: "账户信息" },
    baseInfo: { ID: 424, TR: "基本信息" },
    realName: { ID: 631, TR: "真实姓名" },
    account: { ID: 2424, TR: "账号" },
    telPhoneNumber: { ID: 379, TR: "手机号" },
    email: { ID: 1803, TR: "邮箱" },
    corpName: { ID: 102, TR: "公司名称" },
    code: { ID: "", TR: "编码" },
    corpAddress: { ID: 710, TR: "公司地址" },
    userSetting: { ID: "", TR: "用户设置" },

    entryName: { ID: "", TR: "项目名称" }, //yy add---
    companyYName: { ID: "", TR: "您的公司名" },
    companyType: { ID: "", TR: "类型" },
    constructionParty: { ID: "", TR: "采购方/建设方" },
    projectLocation: { ID: "", TR: "项目所在地" },
    projectCity: { ID: "", TR: "城市" },
    projectArea: { ID: "", TR: "县/区" },
    projectDetailAddress: { ID: "", TR: "详细地址" },
    projectNotes: { ID: "", TR: "备注说明" },

    itemName: { ID: "", TR: "项目名" },
    itemNo: { ID: "", TR: "项目编号" },
    item_start_EndTime: { ID: "", TR: "开始/结束时间" },
    ConsumerName: { ID: "", TR: "业主方" },
    PrjCreateTime: { ID: "", TR: "项目添加时间" },
    CustomerDistrict: { ID: "", TR: "所属区域" },
    C_Address: { ID: "", TR: "地址" },
    itemQuery: { ID: "", TR: "查询" },
    itemDelete: { ID: "", TR: "删除" },
  },
  // 底部footer 栏
  footer: {
    version: { ID: 29, TR: "版本" },
    technical: { ID: 697, TR: "技术支持：上海义维流体科技有限公司" },
    technicalAddres: { ID: "", TR: "备案号为：沪ICP备14049296号-2" },
    copyright: { ID: "", TR: "版权所有：上海义维流体科技有限公司" },
    copyrightAddres: { ID: "", TR: "地址：上海市闵行区江月路999号1幢615" },
    tips: { ID: 2425, TR: "数据仅供参考：如有修改恕不通知 版权所有，盗版必究" },
  },
  // 供水项目
  swproject: {
    projectName: { ID: "", TR: "项目名称" },
    dateTime: { ID: "", TR: "日期时间" },
    projectNo: { ID: "", TR: "项目编号" },
    customerName: { ID: "", TR: "客户名称" },
    consumerName: { ID: "", TR: "终端用户" },
    quoteTotalMoney: { ID: "", TR: "报价单总金额" },
    createTime: { ID: "", TR: "创建时间" },
    saveTime: { ID: "", TR: "保存时间" },
    inquiryDueDate: { ID: "", TR: "询价截止日期" },
    anticipatedOrderDate: { ID: "", TR: "预计订单日期" },
    operation: { ID: "", TR: "操作" },
    editProject: { ID: "", TR: "编辑" },
    addAuth: { ID: "", TR: "添加权限" },
    addItem: { ID: "", TR: "添加工位" },
    query: { ID: "", TR: "查询" },
    add: { ID: "", TR: "添加" },
    marketType: { ID: "", TR: "市场类型" },
    clearSelect: { ID: "", TR: "清空所选收藏列表" },

    basicQuoteInformation: { ID: "", TR: "基本信息" },
    quoteNumber: { ID: "", TR: "报价单编号" },
    quoteStatus: { ID: "", TR: "报价状态" },
    projectStage: { ID: "", TR: "项目阶段" },
    classSale: { ID: "", TR: "报价状态" },
    quoteDisposition: { ID: "", TR: "报价处理" },
    actualCloseDate: { ID: "", TR: "实际关闭日期" },
    quoteDispositionStatus: { ID: "", TR: "报价处理状态" },
    quoteDispositionReason: { ID: "", TR: "报价处理原因" },
    quoteDispositionComments: { ID: "", TR: "报价处理建议" },
    customerAndEndUser: { ID: "", TR: "客户与终端用户" },
    customerName: { ID: "", TR: "客户名称" },
    endUser: { ID: "", TR: "终端用户" },
    countryOfInstallation: { ID: "", TR: "国内/外" },
    country: { ID: "", TR: "国家" },
    province: { ID: "", TR: "省" },
    city: { ID: "", TR: "市" },
    area: { ID: "", TR: "区" },
    addressDetail: { ID: "", TR: "详细地址" },
    customerContact: { ID: "", TR: "联系方式" },
    quotationTimeLine: { ID: "", TR: "报价时间线" },
    inquiryReceivedDate: { ID: "", TR: "询价接收日期" },
    inquiryDueDate: { ID: "", TR: "询价截止日期" },
    anticipatedOrderDate: { ID: "", TR: "预计订单日期" },
    actualQuoteSubmittedDate: { ID: "", TR: "实际报价提交日期" },
    salesInformationSecurity: { ID: "", TR: "销售信息&安全" },
    quoteCurrency: { ID: "", TR: "报价货币" },
    deliveryPort: { ID: "", TR: "交货港口" },
    transaction: { ID: "", TR: "交易方式" },
    exchangeRate: { ID: "", TR: "汇率" },
    otherEditors: { ID: "", TR: "其他编辑者" },
    available: { ID: "", TR: "可选的" },
    selected: { ID: "", TR: "选中的" },
    other: { ID: "", TR: "其他" },
    save: { ID: "", TR: "保存" },
    headSculpture: { ID: "", TR: "头像" },
    no: { ID: "", TR: "编号" },
    name: { ID: "", TR: "名称" },
    usageState: { ID: "", TR: "使用状态" },
    location: { ID: "", TR: "位置" },
    address: { ID: "", TR: "详细地址" },
    back: { ID: "", TR: "返回" },
    automatically: { ID: "", TR: "自动生成" },
  },
  // 简易项目
  simpleProject: {
    tips1: { ID: "", TR: "请至少选中一个型号" },
    tips2: { ID: "", TR: "确认返回？" },
    tips3: { ID: "", TR: "确认删除此型号吗？" },
    tips4: { ID: "", TR: "添加失败" },
    tips5: { ID: "", TR: "添加成功" },
    tips6: { ID: "", TR: "清除收藏列表" },
    auto: { ID: "", TR: "自动生成" },
    someAsCustomer: { ID: "", TR: "和客户一样" },
    itemInfo: { ID: "", TR: "工位信息" },
    creator: { ID: "", TR: "创建人" },

    upload: { ID: "", TR: "上传" },
    notUpload: { ID: "", TR: "未上传" },
    lastEditor: { ID: "", TR: "最后编辑人" },
    tips7: { ID: "", TR: "项目名称不能为空" },
    tips8: { ID: "", TR: "此操作将删除该项目, 是否继续?" },
    tips9: { ID: "", TR: "无法读取到项目信息" },
    tips10: { ID: "", TR: "删除失败" },
    tips11: { ID: "", TR: "删除成功" },
    tips12: { ID: "", TR: "已取消删除操作" },
    tips13: { ID: "", TR: "用户名称不能为空" },
    tips14: { ID: "", TR: "请填选客户" },

    tips15: { ID: "", TR: "修改成功" },
    tips16: { ID: "", TR: "修改失败" },
    tips17: { ID: "", TR: "此操作将清空已填信息, 是否继续?" },
    tips18: { ID: "", TR: "已取消操作" },
  },
  //快速选型-大元
  quickSelection: {
    pressurize: { ID: 923, TR: "增压" },
    groundWater: { ID: "", TR: "地下水" },
    wasteWater: { ID: "", TR: "废水" },
    liftingStation: { ID: "", TR: "提升站" },
    quickSelection: { ID: "", TR: "快速选型" },
    inletPressureType: { ID: "", TR: "入口压力类型" },
    pressurizeType1: { ID: "", TR: "屋顶水箱供水增压" },
    pressurizeType2: { ID: "", TR: "水箱供水增压" },
    pressurizeType3: { ID: "", TR: "市政供水" },
    pressurizeType4: { ID: "", TR: "负压小于8米" },
    selectionParams: { ID: "", TR: "选型参数" },
    stopcocks: { ID: "", TR: "水龙头数" },
    floors: { ID: "", TR: "楼层数" },
    tappingPoint: { ID: "", TR: "分接点" },
    houseType: { ID: "", TR: "房屋类型" },
    tapPressure: { ID: "", TR: "水龙头压力" },
    singleStoryHouses: { ID: "", TR: "单层房屋" },
    doubleDeckerHouse: { ID: "", TR: "双层房屋" },
    outdoorPipelineMaterials: { ID: "", TR: "室外管道材料" },
    outdoorPipelineDiameter: { ID: "", TR: "室外管道口径" },
    outdoorPipelineLength: { ID: "", TR: "室外管道长度" },
    indoorPipelineLength: { ID: "", TR: "室内管道长度" },
    pressureHeadSize: { ID: "", TR: "压头大小确定" },
    crossSectionalArea: { ID: "", TR: "横截面积确定" },
    plasticPipe: { ID: "", TR: "塑料管" },
    maxTappingHeight: { ID: "", TR: "最高分接点高度" },
    buildingHeight: { ID: "", TR: "房屋高度" },
    wellheadHeight: { ID: "", TR: "井口高度" },
    dynamicWaterLevel: { ID: "", TR: "动态水位高度" },
    powerSupply: { ID: "", TR: "电源" },
    houseCableEntry: { ID: "", TR: "房屋电缆入口" },
    cableCrossSectionalArea: { ID: "", TR: "房屋电缆入口" },
    tips1ByGroundWater: { ID: "", TR: "请确定压头大小" },
    tips2ByGroundWater: { ID: "", TR: "请选择房屋类型" },
    tips3ByGroundWater: { ID: "", TR: "请确认电缆总长度" },
    tips4ByGroundWater: { ID: "", TR: "未查询到满足条件的泵" },
    drainage: { ID: "", TR: "排水" },
    drainageType: { ID: "", TR: "排水类型" },
    sewage: { ID: "", TR: "污水" },
    sewageOrWastewater: { ID: "", TR: "污水/废水" },
    maxConveyingDistance: { ID: "", TR: "最大输送距离" },
    pressureTip: {
      tip1: { ID: "", TR: "入口压力类型" },
      tip2: { ID: "", TR: "选择所需的压力类型情况" },
      tip3: { ID: "", TR: "输入水龙头数和楼层数" },
      tip4: { ID: "", TR: "选型结果" },
      tip5: { ID: "", TR: "此块区域可查看符合条件的选型结果" },
      tip6: { ID: "", TR: "请输入楼层数" },
      tip7: { ID: "", TR: "请输入水龙头数" },
    },
    groundWaterTip: {
      tip1: { ID: "", TR: "根据情况输入参数" },
      tip2: { ID: "", TR: "压头确定" },
      tip3: { ID: "", TR: "压头A" },
      tip4: { ID: "", TR: "压头B" },
      tip5: { ID: "", TR: "压头C" },
      tip6: { ID: "", TR: "确定横截面积" },
      tip7: { ID: "", TR: "根据情况输入各段的电缆长度" },
      tip8: { ID: "", TR: "电缆E" },
      tip9: { ID: "", TR: "电缆D" },
      tip10: { ID: "", TR: "电缆F" },
      tip11: { ID: "", TR: "获取选型结果" },
      tip12: { ID: "", TR: "点击选型按钮获取选型结果" },
      tip13: { ID: "", TR: "根据情况输入需要的各段压头值。" },
    },
    wasteWaterTips: {
      tip1: { ID: "", TR: "排水类型类型" },
      tip2: { ID: "", TR: "根据情况选择排水类型" },
      tip3: { ID: "", TR: "输入压头和最大输送距离" },
      tip4: { ID: "", TR: "选型结果" },
      tip5: { ID: "", TR: "此块区域可查看符合条件的选型结果" },
    },
  },
};
